import { version } from "../package.json";

export const CONFIG_MODE = import.meta.env["MODE"];

export const CONFIG_SHA = import.meta.env["VITE_SHA"];

export const CONFIG_VERSION = version;

export const CONFIG_ENVIRONMENT = "__ENVIRONMENT_PLACEHOLDER__";

export const CONFIG_SENTRY_DSN = import.meta.env["VITE_SENTRY_DSN"];

export const CONFIG_SENTRY_DEBUG =
	import.meta.env["VITE_SENTRY_DEBUG"] === "true";
